import React from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Modal,
  ModalHeader,
  Container,
  ModalBody,
  ModalFooter,
  FormText,
  Progress,
} from "reactstrap";
import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";
import { apiService, commonService } from "../../_services";

//Page Utilities
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import SelectListComponent from "../utils/selectList";
import FlightTable from "./flight.table";
import SelectCreatableListComponent from "../utils/selectCreatableList";

//Icons
import AddIcon from "react-icons/lib/md/library-add";
import FlightIcon from "react-icons/lib/md/flight-takeoff";
import { appHelpers, store } from "../../_helpers";
import { operationsService } from "../../_services/operations.service";
const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class FlightViewContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flights: [],
      flightDays: [],
      modal: false,
      modalClass: "",
      //Flight form
      FlightId: false,
      AirlineId: "",
      FlightNumber: "",
      FlightDays: [],
      DepartureAirportId: "",
      DepartureCountryId: "",
      DestinationAirportId: "",
      DestinationCountryId: "",
      IsLocal: false,
      Active: false,

      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      countries: [],
      //Search Filter parameters
      airlines: [],
      departureAirports: [],
      destinationAirports: [],
      filteredFlightNumbers: [],
      searchFlightNumber: "",
      searchAirlineId: "",

      //MakerChecker
      createFlightEntityTypeId: null,
      editFlightEntityTypeId: null,

      //pagination params
      pageSize: 10,
      currentPage: 1,
      totalFlightCounts: 0,
      SEARCH_FLIGHT_URL: appConstants.FLIGHT_URL + "search?showdetails=true",
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { countries, airlinesCarriers, flightDays, entities } = reduxState;
    const { dispatch, depAirports } = this.props;
    if (countries) {
      this.setState({ countries: countries.Results });
    } else {
      this.fetchCountries();
    }
    if (airlinesCarriers) {
      this.setState({ airlines: airlinesCarriers.Results });
    } else {
      this.fetchAirlines();
    }
    if (flightDays) {
      this.setState({ flightDays: flightDays.Days });
    } else {
      this.fetchFlightDays();
    }
    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }
    if (!depAirports) {
      dispatch(commonActions.getDepAirports());
    }

    this.fetchFlights();
  }

  componentWillReceiveProps = function (nextProps) {
    const { alert } = nextProps;
    const { modal, entities } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        // this.setState({error: false, success: alert.message})
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass,
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass,
        });
        this.resetForm();
      }
    }
    if (entities) {
      this.setEntityTypes(entities);
    }
  };

  setEntityTypes = (entities) => {
    let createFlightEntityTypeId;
    let editFlightEntityTypeId;

    entities.forEach((entity) => {
      if (entity.EntityType === appConstants.APP_ENTITIES.CREATE_FLIGHT) {
        createFlightEntityTypeId = entity.EntityTypeId;
      } else if (
        entity.EntityType === appConstants.APP_ENTITIES.UPDATE_FLIGHT
      ) {
        editFlightEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ createFlightEntityTypeId, editFlightEntityTypeId });
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  handleSelectChange = (payload, attribute, stateAttribute) => {
    let currState = this.state;
    currState[stateAttribute] = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[stateAttribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  handleFlightDaysChange = (payload) => {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["FlightDays"] = false;
    this.setState({
      FlightDays: payload,
      componentErrorMessages: errorMessages,
    });
  };

  handleAirlineChange = (target) => {
    if (!(target === null && this.state.searchAirlineId === "")) {
      //Get All flights for airline
      let airlineId = target ? target.Id : "";
      this.setState({
        contentError: false,
        searchAirlineId: airlineId,
        filteredFlightNumbers: [],
        searchFlightNumber: "",
      });
      const { dispatch } = this.props;
      let { pageSize } = this.state;
      dispatch(apiActions.startRequest());
      let payload = {
        From: 0,
        PageSize: pageSize,
        Parameter: { AirlineId: airlineId },
      };

      //Get flight Numbers for airline
      this.fetchAirlineFlightNumbers(airlineId);

      commonService.getFlights(payload).then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          let response = res.response;
          this.setState({
            currentPage: 1,
            flights: response.Results,
            totalFlightCounts: response.TotalCount,
          });
          dispatch(apiActions.endRequest());
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          dispatch(apiActions.endRequest());
        }
      });
    }
  };

  handleFlightChange = (target) => {
    if (!(target === null && this.state.searchFlightNumber === "")) {
      let flightNumber = target ? target.FlightNumber : "";
      this.setState({ contentError: false, searchFlightNumber: flightNumber });
      const { dispatch } = this.props;
      let { pageSize, searchAirlineId } = this.state;

      dispatch(apiActions.startRequest());
      if (flightNumber === "") {
        /*Resolve to get Flights for current Airline*/
        let payload = {
          From: 0,
          PageSize: pageSize,
          Parameter: { AirlineId: searchAirlineId },
        };
        commonService.getFlights(payload).then((res) => {
          if (res.status === appConstants.SUCCESS_RESPONSE) {
            let response = res.response;
            this.setState({
              currentPage: 1,
              flights: response.Results,
              totalFlightCounts: response.TotalCount,
            });
            dispatch(apiActions.endRequest());
          } else if (res.status === appConstants.ERROR_RESPONSE) {
            dispatch(alertActions.error(res.response));
            dispatch(apiActions.endRequest());
          }
        });
      } else {
        //Get a single flight
        commonService.getFlight(flightNumber).then((res) => {
          let response = res.response;
          if (res.status === appConstants.SUCCESS_RESPONSE) {
            // this.setState({currentPage: 1, searchAirlineId : response.Results[0].AirlineId, flights: response.Results, totalFlightCounts: response.TotalCount });
            this.setState({
              currentPage: 1,
              flights: response.Results,
              totalFlightCounts: response.TotalCount,
            });
            if (response.Results.length > 0) {
              this.setState({ searchAirlineId: response.Results[0].AirlineId });
            } else {
              this.setState({ searchAirlineId: searchAirlineId });
            }

            dispatch(apiActions.endRequest());
          } else if (res.status === appConstants.ERROR_RESPONSE) {
            this.notify(response, appConstants.NOTIFY_ERROR);
            dispatch(apiActions.endRequest());
          }
        });
      }
    }
  };

  handleFlightCountryChange = (event, attribute, mode) => {
    let countryCode = event ? event.Code : "";
    let { dispatch } = this.props;
    let errorMessages = this.state.componentErrorMessages;

    if (mode === appConstants.FLIGHT_AIRPORT_DEPARTURE) {
      errorMessages["DepartureCountryId"] = false;
      this.setState({
        componentErrorMessages: errorMessages,
        DepartureCountryId: countryCode,
        DepartureAirportId: "",
      });
    } else if (mode === appConstants.FLIGHT_AIRPORT_DESTINATION) {
      errorMessages["DestinationCountryId"] = false;
      this.setState({
        componentErrorMessages: errorMessages,
        DestinationCountryId: countryCode,
        DestinationAirportId: "",
      });
    }

    if (event) {
      let url =
        appConstants.PAS_URL + "/api/airport/search?countryCode=" + countryCode;
      dispatch(apiActions.startRequest());
      apiService
        .get(url)
        .then((res) => {
          if (mode === appConstants.FLIGHT_AIRPORT_DEPARTURE) {
            this.setState({ departureAirports: res.data.Results });
          } else if (mode === appConstants.FLIGHT_AIRPORT_DESTINATION) {
            this.setState({ destinationAirports: res.data.Results });
          }
          dispatch(apiActions.endRequest());
        })
        .catch((error) => {
          let errorMessage = apiService.interpretErrorResponse(error);
          this.notify(errorMessage, appConstants.NOTIFY_ERROR);
          dispatch(apiActions.endRequest());
        });
    } else {
      if (mode === appConstants.FLIGHT_AIRPORT_DEPARTURE) {
        this.setState({ departureAirports: [] });
      } else if (mode === appConstants.FLIGHT_AIRPORT_DESTINATION) {
        this.setState({ destinationAirports: [] });
      }
    }
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.AirlineId === "") {
      _errs_["AirlineId"] = "Please select airline";
      formValid = false;
    }
    if (this.state.FlightNumber === "") {
      _errs_["FlightNumber"] = "Please enter flight number";
      formValid = false;
    }
    if (this.state.FlightDays.length === 0) {
      _errs_["FlightDays"] = "Please select flight days";
      formValid = false;
    }
    if (this.state.DepartureAirportId === "") {
      _errs_["DepartureAirportId"] = "Please select departure airport";
      formValid = false;
    }
    if (this.state.DestinationAirportId === "") {
      _errs_["DestinationAirportId"] = "Please select destination airport";
      formValid = false;
    }
    if (this.state.DepartureCountryId === "") {
      _errs_["DepartureCountryId"] = "Please select departure country";
      formValid = false;
    }
    if (this.state.DestinationCountryId === "") {
      _errs_["DestinationCountryId"] = "Please select destination country";
      formValid = false;
    }

    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  onRemove = (notification) => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      FlightId: false,
      AirlineId: "",
      FlightNumber: "",
      DestinationCountryId: "",
      DepartureAirportId: "",
      DestinationAirportId: "",
      DepartureCountryId: "",
      Active: false,
      IsLocal: false,
      FlightDays: [],
    });
    this.resetError();
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  processSubmit = () => {
    const userRole = appHelpers.getActiveUser().AviRole;
    let { FlightId, FlightDays } = this.state;

    let payload = {
      AirlineId: this.state.AirlineId,
      FlightNumber: this.state.FlightNumber,
      DepartureAirportId: this.state.DepartureAirportId,
      DestinationAirportId: this.state.DestinationAirportId,
      IsLocal: this.state.IsLocal,
      Active: this.state.Active,
    };

    let formattedFlightDays = [];
    for (let item of FlightDays) {
      formattedFlightDays.push({
        DayId: item.Id,
      });
    }
    payload.FlightDays = formattedFlightDays;

    if (FlightId) {
      payload.Id = FlightId;
    }

    if (
      userRole === appConstants.ROLES.SUPER_ADMIN ||
      userRole === appConstants.ROLES.BSP_ADMIN
    ) {
      this.createFlight(payload);
    } else {
      this.createMakerChecker(payload);
    }

    // commonService.manageFlight(payload)
    //      .then((res) => {
    //          if (res.status === appConstants.SUCCESS_RESPONSE) {
    //              this.toggle(null, 'modalSlide');
    //              let msg = (payload.Id) ? 'Flight edited successfully'  : 'Flight created successfully';
    //              this.notify(msg, appConstants.NOTIFY_SUCCESS);
    //              this.fetchFlights(currentPage);
    //          }
    //          else if(res.status === appConstants.ERROR_RESPONSE){
    //              dispatch(alertActions.error(res.response));
    //              dispatch(apiActions.endRequest());
    //          }
    //      });
  };

  createFlight = (payload) => {
    const { dispatch } = this.props;
    const { currentPage } = this.state;

    commonService.manageFlight(payload).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Flight edited successfully"
          : "Flight created successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        this.fetchFlights(currentPage);
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  createMakerChecker = (payload) => {
    const { dispatch } = this.props;
    let { FlightId, createFlightEntityTypeId, editFlightEntityTypeId } =
      this.state;
    const { authentication } = store.getState();

    /* Maker Checker */
    let payloadTemplate = {
      Airline: this.interpretAirlines(this.state.AirlineId),
      FlightNumber: this.state.FlightNumber,
      DepartureAirport: this.interpretAirport(this.state.DepartureAirportId),
      DestinationAirport: this.interpretAirport(
        this.state.DestinationAirportId
      ),
      isLocal: this.state.isLocal ? "Yes" : "No",
      Active: this.state.Active ? "Yes" : "No",
    };

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${appConstants.PAS_URL}/api/Flight/save`,
      EntityTypeId: createFlightEntityTypeId,
      CreatedBy: authentication.user.userName,
    };

    if (FlightId) {
      makerCheckerPayload.EntityTypeId = editFlightEntityTypeId;
    }

    dispatch(apiActions.startRequest());
    commonService.createMakerChecker(makerCheckerPayload).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Flight update sent successfully"
          : "Flight creation sent successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  fetchFlightDays = () => {
    const { dispatch } = this.props;
    dispatch(commonActions.getAllFlightDays())
      .then(() => {
        let { flightDays } = this.props;
        this.setState({ flightDays: flightDays.Days });
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
      });
  };

  fetchCountries = () => {
    const { dispatch } = this.props;
    dispatch(commonActions.getAllCountries())
      .then(() => {
        let { countries } = this.props;
        this.setState({ countries: countries.Results });
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
      });
  };

  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch, airlinesCarriers } = this.props;
    if (!airlinesCarriers) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        let { airlinesCarriers } = this.props;
        this.setState({ airlines: airlinesCarriers.Results });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  fetchFlights = (pageNumber) => {
    let { pageSize, searchAirlineId, searchFlightNumber } = this.state;
    this.setState({ contentError: false });
    const { dispatch } = this.props;

    let fromIndex;

    if (pageNumber === undefined) {
      dispatch(apiActions.startFullPageRequest());
      fromIndex = 0;
      pageNumber = 1;
    } else {
      fromIndex = pageSize * (pageNumber - 1);
      dispatch(apiActions.startRequest());
    }
    let payload = {
      From: fromIndex,
      PageSize: pageSize,
      Parameter: {
        AirlineId: searchAirlineId,
        FlightNumber: searchFlightNumber,
      },
    };
    commonService.getFlights(payload).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        let response = res.response;
        this.setState({
          currentPage: pageNumber,
          flights: response.Results,
          totalFlightCounts: response.TotalCount,
        });
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  fetchAirlineFlightNumbers = (airlineId) => {
    this.setState({ contentError: false, filteredFlightNumbers: [] });
    commonService.getAirlinesFlightNumbers(airlineId).then((res) => {
      let response = res.response;
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.setState({ filteredFlightNumbers: response.Results });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        this.notify(response, appConstants.NOTIFY_ERROR);
      }
    });
  };

  passFlightDetails = (flight) => {
    let flightDaysIndex = 0;
    let formattedFlightDays = [];
    for (let item of flight.FlightDays) {
      formattedFlightDays.push({
        Id: item.DayId,
        Name: flight.FlightDaysNames[flightDaysIndex],
      });
      flightDaysIndex += 1;
    }

    let { dispatch } = this.props;

    let departingCountryCode = flight.DepartureAirport.CountryCode;
    let url =
      appConstants.PAS_URL +
      "/api/airport/search?countryCode=" +
      departingCountryCode;

    let departingAirports = [];
    dispatch(apiActions.startRequest());
    apiService
      .get(url)
      .then((res) => {
        departingAirports = res.data.Results;
        let destinationCountryCode = flight.DestinationAirport.CountryCode;
        let url =
          appConstants.PAS_URL +
          "/api/airport/search?countryCode=" +
          destinationCountryCode;
        apiService
          .get(url)
          .then((res) => {
            this.setState({
              FlightId: flight.Id,
              AirlineId: flight.AirlineId,
              FlightNumber: flight.FlightNumber,
              DepartureAirportId: flight.DepartureAirportId,
              DepartureCountryId: flight.DepartureAirport.CountryCode,
              DestinationAirportId: flight.DestinationAirportId,
              DestinationCountryId: flight.DestinationAirport.CountryCode,
              FlightDays: formattedFlightDays,
              IsLocal: flight.IsLocal,
              Active: flight.Active,
              departureAirports: departingAirports,
              destinationAirports: res.data.Results,
            });
            dispatch(apiActions.endRequest());
            this.toggle(null, "modalSlideIn");
          })
          .catch((error) => {
            let errorMessage = apiService.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            dispatch(apiActions.endRequest());
          });
      })
      .catch((error) => {
        let errorMessage = apiService.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
      });
  };
  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  toggleCheckbox = (attribute) => {
    let currState = this.state;
    currState[attribute] = !currState[attribute];
    this.setState(currState);
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  interpretAirlines(airlineId) {
    const { Results } = this.props.airlinesCarriers;
    if (Results) {
      const airlineName = Results.find((airline) => airline.Id === airlineId);
      if (airlineName) return airlineName.Name;
    }
  }

  interpretAirport(airportId) {
    const { Results } = this.props.depAirports;
    if (Results) {
      const airportName = Results.find((airport) => airport.Id === airportId);
      if (airportName) return airportName.Name;
    }
  }

  handleAirlinesDownload = (pageNumber) => {
    let { pageSize, currentPage, searchAirlineId, searchFlightNumber } = this.state;
  const { dispatch } = this.props;
  
  // Calculate from index based on current page
  let fromIndex = pageSize * (currentPage - 1);

  let payload = {
    From: fromIndex,
    PageSize: pageSize,
    Parameter: {
      AirlineId: searchAirlineId,
      FlightNumber: searchFlightNumber,
    },
  };
  dispatch(apiActions.startRequest());
    operationsService
      .flightsDownload(payload)
      .then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          // const fileUrl = res.response.data.File;
          // window.open(fileUrl, "_blank");
          let response = res.response.data;
  
          const isBase64 = response.base64File ? true : false;
          const fileData = response.base64File || response; // filestream is in response directly
          // const mimeType = response.type || "application/pdf";
          // normalize mime type
          let mimeType = response.type || "application/pdf";
          if (mimeType === "application/xls") {
            mimeType = "application/vnd.ms-excel"; // correct for old .xls
          }
          appHelpers.downloadFileV2(
            fileData,
            "Flights_Report",
            isBase64,
            mimeType
          );
        }
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        dispatch(alertActions.error("Download failed"));
        dispatch(apiActions.endRequest());
      });
  };
  render() {
    let modalResponse = this.renderPageResponse();
    let { requesting, pageRequesting } = this.props;
    let {
      contentError,
      componentErrorMessages,
      currentPage,
      pageSize,
      totalFlightCounts,
      airlines,
      flights,
      filteredFlightNumbers,
      flightDays,
      countries,
      departureAirports,
      destinationAirports,
    } = this.state;

    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}

            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                <div className="row">
                  <h6 className="mb-4 col-md-8 text-uppercase pull-left">
                    Flight Records
                    <FormText color="muted">
                      {totalFlightCounts > 0 && (
                        <div>
                          <FlightIcon size="18" color="#43a8df" />
                          &nbsp;
                          <span>
                            {totalFlightCounts}&nbsp;
                            {totalFlightCounts === 1
                              ? "flight matched"
                              : "flights matched"}
                          </span>
                        </div>
                      )}
                    </FormText>
                  </h6>
                  <div className="mb-4 col-md-4 text-right">
                    <Button
                      className="btn-avi-primary"
                      onClick={(e) => this.toggle(e, "modalSlideIn")}
                    >
                      <AddIcon color="#ffffff" size="20" />
                      &nbsp;Create Flight
                    </Button>{" "}
                  </div>
                </div>

                <div>
                  <Form onSubmit={this.fetchFlights}>
                    <Row>
                      <Col sm="4">
                        <FormGroup className="mb-4">
                          <SelectListComponent
                            placeholder={"Select Airline..."}
                            data={airlines}
                            valueKey="Id"
                            textField="Name"
                            selectValue={this.state.searchAirlineId}
                            onValueChange={(payload) =>
                              this.handleAirlineChange(payload)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="4">
                        <FormGroup className="mb-4">
                          <SelectCreatableListComponent
                            data={filteredFlightNumbers}
                            placeholder={"Type Flight Number"}
                            valueKey="FlightNumber"
                            textField="FlightNumber"
                            selectValue={this.state.searchFlightNumber}
                            onValueChange={(payload) =>
                              this.handleFlightChange(payload)
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </div>

                {!pageRequesting && totalFlightCounts > 0 && (
                  <FlightTable
                    currentPage={currentPage}
                    pageDataCallback={this.fetchFlights}
                    data={flights}
                    pageSize={pageSize}
                    totalFlightCounts={totalFlightCounts}
                    editCallback={this.passFlightDetails}
                    handleAirlinesDownload={this.handleAirlinesDownload}
                  />
                )}

                {!pageRequesting && !requesting && totalFlightCounts === 0 && (
                  <PageEmptyContent message="No record match your search!" />
                )}

                <Modal
                  size={"lg"}
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  className={this.state.modalClass}
                >
                  <ModalHeader toggle={this.toggle}>Flight</ModalHeader>
                  <Form onSubmit={this.handleSubmit}>
                    <ModalBody>
                      {modalResponse}
                      <Container>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.AirlineId
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label for="airline">Airline</Label>
                              <SelectListComponent
                                disabled={this.state.FlightId}
                                data={airlines}
                                valueKey="Id"
                                textField="Name"
                                selectValue={this.state.AirlineId}
                                onValueChange={(payload) =>
                                  this.handleSelectChange(
                                    payload,
                                    "Id",
                                    "AirlineId"
                                  )
                                }
                              />
                              {componentErrorMessages.AirlineId && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.AirlineId}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.FlightNumber
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Flight Number</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.FlightNumber}
                                onChange={(event) =>
                                  this.handleChange(event, "FlightNumber")
                                }
                              />
                              {componentErrorMessages.FlightNumber && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.FlightNumber}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.FlightDays
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Flight Days</Label>
                              <SelectListComponent
                                data={flightDays}
                                multiSelectMode={true}
                                valueKey="Id"
                                textField="Name"
                                selectValue={this.state.FlightDays}
                                onValueChange={(payload) =>
                                  this.handleFlightDaysChange(payload)
                                }
                              />
                              {componentErrorMessages.FlightDays && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.FlightDays}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .DepartureCountryId
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label for="DepartureCountryId">
                                Departing Country
                              </Label>
                              <SelectListComponent
                                data={countries}
                                valueKey="Code"
                                textField="Name"
                                selectValue={this.state.DepartureCountryId}
                                onValueChange={(payload) =>
                                  this.handleFlightCountryChange(
                                    payload,
                                    "DepartureCountryId",
                                    appConstants.FLIGHT_AIRPORT_DEPARTURE
                                  )
                                }
                              />
                              {componentErrorMessages.DepartureCountryId && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.DepartureCountryId}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .DepartureAirportId
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label for="DepartureAirportId">
                                Departing Airport
                              </Label>
                              <SelectListComponent
                                data={departureAirports}
                                valueKey="Id"
                                textField="Name"
                                selectValue={this.state.DepartureAirportId}
                                onValueChange={(payload) =>
                                  this.handleSelectChange(
                                    payload,
                                    "Id",
                                    "DepartureAirportId"
                                  )
                                }
                              />
                              {componentErrorMessages.DepartureAirportId && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.DepartureAirportId}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .DestinationCountryId
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label for="DestinationCountryId">
                                Destination Country
                              </Label>
                              <SelectListComponent
                                data={countries}
                                valueKey="Code"
                                textField="Name"
                                selectValue={this.state.DestinationCountryId}
                                onValueChange={(payload) =>
                                  this.handleFlightCountryChange(
                                    payload,
                                    "DestinationCountryId",
                                    appConstants.FLIGHT_AIRPORT_DESTINATION
                                  )
                                }
                              />
                              {componentErrorMessages.DestinationCountryId && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.DestinationCountryId}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .DestinationAirportId
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label for="DestinationAirportId">
                                Destination Airport
                              </Label>
                              <SelectListComponent
                                data={destinationAirports}
                                valueKey="Id"
                                textField="Name"
                                selectValue={this.state.DestinationAirportId}
                                onValueChange={(payload) =>
                                  this.handleSelectChange(
                                    payload,
                                    "Id",
                                    "DestinationAirportId"
                                  )
                                }
                              />
                              {componentErrorMessages.DestinationAirportId && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.DestinationAirportId}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12">
                            <FormGroup>
                              <input
                                type="checkbox"
                                className="checkbox-control"
                                name="disabled"
                                checked={this.state.IsLocal}
                                onChange={() => this.toggleCheckbox("IsLocal")}
                              />
                              <span className="checkbox-label">
                                &nbsp;Is local?
                              </span>
                              &nbsp;&nbsp;
                              <input
                                type="checkbox"
                                className="checkbox-control"
                                name="disabled"
                                checked={this.state.Active}
                                onChange={() => this.toggleCheckbox("Active")}
                              />
                              <span className="checkbox-label">
                                &nbsp;Active?
                              </span>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn-avi-primary" disabled={requesting}>
                        {" "}
                        Proceed{" "}
                      </Button>{" "}
                      <Button color="secondary" onClick={this.toggle}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Form>
                  {requesting && <div className={"loading-dot active"} />}
                </Modal>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const {
    modal,
    alert,
    countries,
    airlinesCarriers,
    flightDays,
    entities,
    depAirports,
  } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert,
    airlinesCarriers,
    countries,
    flightDays,
    entities,
    depAirports,
  };
}
export default connect(mapStateToProps)(FlightViewContent);



// WEBPACK FOOTER //
// ./src/views/flight/view-content.js